import PlayGameImg from "../../assets/images/cms/play-game-modal-icon.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPendingGameAPI } from "../../api/game";
import { useMutation } from "@tanstack/react-query";
import useToast from "../../hooks/useToast";
import SecondaryBtn from "../button/SecondaryBtn";
import PrimaryBtn from "../button/PrimaryBtn";

const PlayGameModal = ({ isOpen, onClose, selectedGame }) => {
  const navigate = useNavigate();

  const { mutate: resetPendingGame, isPending: isResettingPendingGame } = useMutation({
    mutationFn: resetPendingGameAPI,
    onSuccess: (data) => {
      navigate(`/game/${selectedGame?._id}`);
    },
    onError: (error) => {
      useToast(error.message, "error");
      onClose();
    },
  });

  const handleRestartGame = () => {
    localStorage.removeItem("endGamePayload");
    localStorage.removeItem("currentGame");
    localStorage.removeItem("gameResult");
    resetPendingGame({ game_id: selectedGame?._id });
  };
  const handleContinueGame = () => {
    navigate(`/game/${selectedGame?._id}`);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
      <div className="modal bg-white-500 2xl:rounded-[2.083vw] lg:rounded-[40px] md:rounded-4xl rounded-3xl 2xl:p-[2vw] xl:p-10 md:p-7 p-4 2xl:max-w-[26.04vw] max-w-[500px] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
        <div className="text-center">
          <img
            src={PlayGameImg}
            alt=""
            className="w-auto 2xl:h-[7.29vw] md:h-36 h-20 landscape:max-lg:h-20 mx-auto 2xl:mb-[1.50vw] md:mb-[30px] mb-3 landscape:max-lg:mb-3 rtl:-scale-x-100"
          />
          <h4 className="2xl:text-[1.5625vw]/[1.7vw] xl:text-3xl/6 text-2xl/6 font-bold text-primary-orange 2xl:mb-[0.42vw] md:mb-2 mb-1 landscape:max-lg:mb-1">
            Continue from where you left off
          </h4>
          <p className="2xl:text-[1.041vw]/[1.15vw] md:text-xl/tight text-base/tight landscape:max-lg:text-base/tight text-black-800 text-center font-bold">
            You have an active game <span className="font-bold">{selectedGame?.game_name}</span>, do you want to
            continue playing or restart?
          </p>
          <div className="flex flex-row 2xl:gap-[1vw] gap-2 justify-center w-full 2xl:mt-[1.67vw] xl:mt-8 md:mt-5 mt-4 landscape:max-lg:mt-4">
            <SecondaryBtn onClick={handleContinueGame} className="w-1/2 lg:mb-0 md:mb-0 mb-0">
              Continue
            </SecondaryBtn>
            <PrimaryBtn onClick={handleRestartGame} className="w-1/2 lg:mb-0 md:mb-0 mb-0" isLoading={isResettingPendingGame}>
              Starting Over
            </PrimaryBtn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayGameModal;
